import ExternalApplicationService from '@/services/titan/ExternalApplicationService';
import { createAuthorizationCustomService } from '../authorization';
import { type ServiceConfig } from '../../ServiceRegistry';
import FundingKpiService from '@/services/titan/FundingKpiService';
import DigitalConnectKpiService from '@/services/titan/DigitalConnectKpiService';
import CncSummaryMetricsService from '@/services/titan/CncSummaryMetricsService';
import AuthorizationUserMetricsService from '@/services/titan/AuthorizationUserMetricsService';
import ResiAgaMetricsService from '@/services/titan/ResiAgaMetricsService';

/**
 * Titan federated module — registers Titan-specific facades on the host registry.
 */
export const titanServices: ServiceConfig[] = [
  {
    name: 'externalApplicationService',
    factory: () => new ExternalApplicationService(),
  },
  {
    name: 'fundingKpiService',
    factory: () => new FundingKpiService(),
  },
  {
    name: 'digitalConnectKpiService',
    factory: () => new DigitalConnectKpiService(),
  },
  {
    name: 'cncSummaryMetricsService',
    factory: () => new CncSummaryMetricsService(),
  },
  {
    name: 'authorizationUserMetricsService',
    factory: () => new AuthorizationUserMetricsService(),
  },
  {
    name: 'resiAgaMetricsService',
    factory: () => new ResiAgaMetricsService(),
  },
];

export const titanServiceUtils = {
  getServiceNames: () => titanServices.map(s => s.name),
  isTitanService: (name: string) => titanServices.some(s => s.name === name),
  getBasePath: () => '/titan',
};

/** Prefer {@link createAuthorizationCustomService}; kept for callers that still import from the Titan bundle. */
export const createTitanCustomService = createAuthorizationCustomService;
